var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('review-modal'),_c('post-review-modal'),_c('button',{staticClass:"btn btn-primary btn-lg floating m-4 d-none d-lg-block",attrs:{"type":"submit"},on:{"click":function($event){return _vm.showModal()}}},[_vm._v(" "+_vm._s(_vm.$t('review-us'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }